import { createParser } from "@walmart/sophia-tagging"

export default createParser({
	fields: [{ from: "organization", to: "org", validate: [] }],
})
